import { useEffect, useReducer, useMemo } from "react";
import BookFiltersStore from "../../../Flux/Stores/BookFiltersStore";
import PlacementDataStore from "../../../Flux/Stores/PlacementDataStore";

export default function useSyncStatuses({ campaignMetaData }) {
	const [syncStatuses, setSyncStatuses] = useReducer(() => {
		return BookFiltersStore.getSyncStatuses();
	}, []);

	useEffect(() => {
		PlacementDataStore.on("sync_success", setSyncStatuses);
		PlacementDataStore.on("sync_fail", setSyncStatuses);

		setSyncStatuses();

		return () => {
			PlacementDataStore.removeListener("sync_success", setSyncStatuses);
			PlacementDataStore.removeListener("sync_fail", setSyncStatuses);
		};
	}, []);

	const prismaAPIEnabled = useMemo(() => {
		const statuses = BookFiltersStore.getSyncStatuses();
		if (campaignMetaData && statuses) {
			const { SyncStatus } = statuses.find(({ MasterPlatformID }) => MasterPlatformID == 5);
			const validStatusIDs = [3, 6];
			let platformPKExists = false;
			if (campaignMetaData?.PlatformCampaignPK) {
				try {
					platformPKExists = JSON.parse(campaignMetaData.PlatformCampaignPK).some((platform) => {
						return platform.MasterPlatformID === 5 && platform.PlatformPK;
					});
				} catch {
					console.log("PlatformCampaignPK is not in JSON format");
				}
			}
			return SyncStatus && validStatusIDs.includes(campaignMetaData.ExternalSystemStatusID) && platformPKExists;
		}
		return false;
	}, [campaignMetaData]);

	const displayPrismaStatusFilter = useMemo(() => {
		const statuses = BookFiltersStore.getSyncStatuses();
		if (statuses) {
			const { SyncStatus } = statuses.find(({ MasterPlatformID }) => MasterPlatformID == 5);
			return SyncStatus;
		}
		return false;
	});

	const platformSyncStatus = useMemo(() => {
		return syncStatuses?.find(({ MasterPlatformID }) => MasterPlatformID == campaignMetaData?.PlatformID)?.SyncStatus;
	}, [syncStatuses]);

	return { syncStatuses, displayPrismaStatusFilter, prismaAPIEnabled, platformSyncStatus };
}
